import { createContext, type FC, type PropsWithChildren, useContext, useMemo } from 'react'

type InteractionContextValue = {
  isOpen: boolean
  /** Signals that the interaction is finished, so the manager can look for the next one. */
  onDismiss: () => void
}

const InteractionContext = createContext<InteractionContextValue | null>(null)

export function useInteraction(): InteractionContextValue {
  const context = useContext(InteractionContext)

  if (!context) {
    throw new Error('useInteraction must be used within an InteractionProvider')
  }

  return context
}

export const InteractionProvider: FC<PropsWithChildren<InteractionContextValue>> = ({
  children,
  isOpen,
  onDismiss,
}) => {
  const value: InteractionContextValue = useMemo(() => ({ isOpen, onDismiss }), [isOpen, onDismiss])

  return <InteractionContext.Provider value={value}>{children}</InteractionContext.Provider>
}
